import React, {Fragment, useRef} from 'react';
import {Form, Field} from 'react-final-form';
import {Popup, Text, Select, Chip_input, Explanation_text} from '../../../components';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import DeleteIcon from '@material-ui/icons/Delete';
import Button from '@material-ui/core/Button';
import { FieldArray } from 'react-final-form-arrays';
import arrayMutators from 'final-form-arrays';
import {connect} from 'react-redux';

function Workspace_setup_popup(props){


  function onSubmit(params){
    let old_emails=(props.workspace.workspace_email_bcc!=null)?props.workspace.workspace_email_bcc.emails:'[]'; let new_emails=[]; if(params.email_bcc==null){new_emails==null;}else{for(let x of params.email_bcc){new_emails.push(x.email);}} params.email_bcc=new_emails;
    props.updateWorkspace(props.workspace.id, params);
  }

  let initial_values={};
  initial_values.unassigned_public=(props.workspace.unassigned_public==undefined)?false:props.workspace.unassigned_public
  initial_values.name=props.workspace.name;
  initial_values.scrape_websites=props.workspace.scrape_websites
  initial_values.email_phone_deduplication=props.workspace.email_phone_deduplication;
  initial_values.company_name_deduplication=props.workspace.company_name_deduplication;
  initial_values.domain_default_deduplication=props.workspace.domain_default_deduplication;
  initial_values.longitude_latitude_deduplication=props.workspace.longitude_latitude_deduplication
  initial_values.longitude_latitude_wide_deduplication=props.workspace.longitude_latitude_wide_deduplication
  initial_values.currency=props.workspace.currency;
  initial_values.unsubscribe_button_default_on=props.workspace.unsubscribe_button_default_on;
  if(props.workspace.workspace_email_bcc!=null){let xs=[]; let index=0; for(let e of JSON.parse(props.workspace.workspace_email_bcc.emails)){xs.push({id:index, email:e}); index+=1;} initial_values.email_bcc=xs;}
  
  //<Grid item xs={12}  style={{marginTop:'10px', paddingLeft:'10px'}}><Field name='company_name_deduplication'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Company name deduplication"/>}/>}</Field></Grid>
    //        <Grid item xs={12} style={{marginTop:'10px', paddingLeft:'10px'}}><Field name='email_phone_deduplication'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="email_phone_deduplication"/>}/>}</Field></Grid>
  //<Grid item xs={12}  style={{marginTop:'10px', paddingLeft:'10px'}}><Field name='scrape_websites'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="workspace_setup_scrape_websites"/>}/>}</Field></Grid>

  return(
    <Form
      onSubmit={onSubmit}
      initialValues={initial_values}
      mutators={{
        ...arrayMutators
      }}
    >
      {form_props => (
        <form onSubmit={form_props.handleSubmit}>
        <Popup handleClose={props.handleClose} always_open accept_button='Save' accept_button_click={()=>{form_props.form.submit(); form_props.form.reset(); props.handleClose()}} title='workspace_setup_title' content={
          <Grid container style={{width:'95vw', maxWidth:'600px'}}>
            <Grid item xs={12} style={{marginTop:'20px'}}><Text title='workspace_setup_label_name' name='name'/></Grid>
            <Grid item xs={12} sm={6} style={{marginTop:'10px'}}><Select select_data={[{id:'$', name:'$'},{id:'£', name:'£'},{id:'€', name:'€'}]} title='Currency' name='currency'/></Grid>
            <Grid item xs={12} style={{marginTop:'10px', paddingLeft:'10px'}}><Field name='unassigned_public'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="workspace_setup_label_unassigned_public"/>}/>}</Field></Grid>
            <Grid item xs={12}><Typography style={{marginTop:'30px', marginLeft:'10px', fontWeight:'bold'}} color='primary'>Email settings</Typography></Grid>
            <Grid item xs={12} style={{marginTop:'10px', marginBottom:'0px', paddingLeft:'10px'}}><Field name='unsubscribe_button_default_on'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Add unsubscribe link to templates"/>}/>}</Field></Grid>
            <Grid item xs={12} style={{marginTop:'-30px'}}><Field name={`email_bcc`}>{(f)=><Chip_input title='workspace_setup_label_email_bcc' no_title name='email_bcc' value={f.input.value} onChange={f.input.onChange} value_name='email'/>}</Field></Grid>
            <Grid item xs={12}><Typography style={{marginTop:'30px', marginLeft:'10px', fontWeight:'bold'}} color='primary'>Search and scraping settings</Typography></Grid>
            <Grid item xs={12}  style={{marginTop:'10px', paddingLeft:'10px'}}><Field name='domain_default_deduplication'>{(f)=><FormControlLabel control={<Checkbox checked={f.input.value} onChange={f.input.onChange}/>} label={<Explanation_text inline text="Strict domain deduplication"/>}/>}</Field></Grid>
            <Grid item xs={12} sm={6} style={{marginTop:'20px', marginBottom:'20px'}}><Text type='number' title='workspace_setup_lat_long_deduplication' name='longitude_latitude_deduplication'/></Grid>
            <Grid item xs={12} sm={6} style={{marginTop:'20px', marginBottom:'20px'}}><Text type='number' title='workspace_setup_lat_long_wide_deduplication' name='longitude_latitude_wide_deduplication'/></Grid>
          </Grid>
        }/>
        </form>
      )}
    </Form>
  )
}


export default connect(ss, dd)(Workspace_setup_popup);

function ss(state){
  return{}
}

function dd(dispatch){
  return{
    updateWorkspace:(id, params)=>{dispatch({type:'REQUEST_UPDATE_WORKSPACE', id:id, payload:params});}
  }
}
